<template>
    <div class="MessageContent">
        <v-spacer v-if="!isUser"></v-spacer>
        <div class="message-text-container">
            <v-avatar size="22" color="white" class="react-icon" v-if="react_icon">
              <emoji-parser :emoji="react_icon"/>
            </v-avatar>
            <div class="message-text" :class="isUser ? 'user' : 'bot'">
                <span v-html="replaceLinkInTextContent(content.text)" class="text-pre"></span>
                <span v-if="needViewMore && showViewMore" @click="toggleViewMore" class="view-more">
                    {{ $t('viewMore') }}
                </span>
            </div>
            <div>
                <button class="message-btn-quick" v-for="(b, ib) in content.buttons" :key="ib">
                    {{ b.title }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";

export default {
    name: "MessageContentQuickReply",
    extends: MessageContent
}
</script>
<style scoped lang="scss">
@import "../../style/message-box.scss";
::v-deep.react-icon {
  position: absolute;
  bottom: -10px;
  right: 5px;
}
</style>
